import {
  CategoryCardRequest,
  CategoryTreeViewRequest,
} from "@/types/CategoryType";
import http from "./httpService";

export function getCategoryCard({
  id,
  parentId,
  selected,
  take,
}: CategoryCardRequest) {
  return http
    .post(`/CategoryApi/GetSelectedCategoryCard`, {
      id,
      parentId,
      selected,
      take,
    })
    .then(({ data }) => data);
}

export function getCategoryMenu() {
  return http
    .get(`/CategoryApi/GetSelectedCategoryTreeView`)
    .then(({ data }) => data);
}

export function getCategoryTreeView({
  text,
  selected,
  take,
}: CategoryTreeViewRequest) {
  return http
    .post("/CategoryApi/GetCategoriesTreeView", {
      text,
      selected,
      take,
    })
    .then(({ data }) => data);
}
